import { EffectCallback, useEffect } from 'react';

export const useEffectOnce = (effect: EffectCallback) => {
  // eslint-disable-next-line
  useEffect(effect, []);
};
